var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChaticon = function SvgChaticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "#fff",
    viewBox: "0 0 15 16",
    xmlSpace: "preserve",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 16c-.7 0-1.1-.3-1.2-.8-.3-.8.5-1.3.8-1.5.6-.4.9-.7 1-1 0-.2-.1-.4-.3-.7 0 0 0-.1-.1-.1C.5 10.6 0 9 0 7.4 0 3.3 3.4 0 7.5 0S15 3.3 15 7.4s-3.4 7.4-7.5 7.4c-.5 0-1-.1-1.5-.2C3.4 15.9 1.5 16 1.5 16h-.2zm2-5.1c.5.7.7 1.5.6 2.2 0 .1-.1.3-.1.4.5-.2 1-.4 1.6-.7.2-.1.4-.2.6-.1h.1c.4.1.9.2 1.4.2 3 0 5.5-2.4 5.5-5.4S10.5 2 7.5 2 2 4.4 2 7.4c0 1.2.4 2.4 1.2 3.3 0 .1.1.1.1.2z"
  })));
};
export default SvgChaticon;